import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';

export interface OnlyFansMetricsSubscribedAtVsTotalSalesDetailsDataPoint {
    _id: {
        interval: Date;
        createdAt: Date;
    };
    count: number;
    total?: number;
    totalNet?: number;
    totalWithoutSubscriptions?: number;
    totalNetWithoutSubscriptions?: number;
}

const useSextforceMetricsSubscribedAtVsTotalSalesDetails = (
    subscriberId: string | undefined,
    metricType: 'trial' | 'campaign',
    metricId: string | undefined,
    timezone: string,
    staggerPreviousStepReady: boolean = true,
) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const params = useParams();
    const dialog = useDialog();
    const axios = useAxios();

    // Fetch Report
    const fetchReport = async (): Promise<OnlyFansMetricsSubscribedAtVsTotalSalesDetailsDataPoint[]> => {
        const query: string = `${settingsContext.routes.metrics.base}${subscriberId}/${
            metricType === 'campaign' ? 'promocampaigns' : 'trials'
        }/${metricId}/subscribedat?timezone=${timezone}`;

        const data = await axios
            .get(query, {
                // timeout 20 minutes
                timeout: 20 * 60 * 1000,
            })
            .then(response => response.data)
            .catch(error => {
                console.error(error);

                handleHttpError(error, dialog);

                return [];
            });

        return data;
    };

    return useQuery(
        ['metricsPromoCampaingSubscribedAtVsSales', params.userId, subscriberId, metricType, metricId, timezone],
        () => fetchReport(),
        {
            refetchOnWindowFocus: false,
            staleTime: 60 * 60 * 1000,
            enabled: Boolean(
                userContext.jwtToken && settingsContext.apiKey && params.userId && subscriberId && metricId && staggerPreviousStepReady,
            ),
        },
    );
};

export default useSextforceMetricsSubscribedAtVsTotalSalesDetails;
